import { ArrowRight, Plane } from 'lucide-react';
import { useState, useEffect } from 'react';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1507812984078-917a274065be';

const WORDS = ['Extraordinárias', 'Inesquecíveis', 'Únicas'];

export default function Hero() {
  const [displayText, setDisplayText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [speed, setSpeed] = useState(100);

  useEffect(() => {
    const currentWord = WORDS[wordIndex];
    const timer = setTimeout(() => {
      if (!isDeleting) {
        if (displayText.length < currentWord.length) {
          setDisplayText(currentWord.substring(0, displayText.length + 1));
          setSpeed(100);
        } else {
          setSpeed(2000);
          setIsDeleting(true);
        }
      } else {
        if (displayText.length > 0) {
          setDisplayText(displayText.substring(0, displayText.length - 1));
          setSpeed(50);
        } else {
          setIsDeleting(false);
          setWordIndex((prev) => (prev + 1) % WORDS.length);
          setSpeed(500);
        }
      }
    }, speed);
    return () => clearTimeout(timer);
  }, [displayText, isDeleting, wordIndex, speed]);

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${HERO_IMAGE}')` }}>
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      <div className="container relative z-10 flex flex-col items-center justify-center text-center h-full w-full">
        <div className="max-w-3xl mx-auto space-y-6 fade-in-up">
          <div className="inline-block px-6 py-3 bg-white/15 border border-white/40 rounded-full backdrop-blur-sm">
            <p className="text-white font-bold text-sm sm:text-base flex items-center justify-center gap-2">
              <Plane size={16} />
              Explore o Mundo com Estilo
            </p>
          </div>

          <h1 className="text-5xl sm:text-6xl md:text-8xl font-black text-white leading-tight text-center drop-shadow-lg">
            Viagens
            <span className="block text-white min-h-[1.2em]">
              {displayText}
              <span className="animate-pulse-soft">|</span>
            </span>
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-white/95 max-w-3xl mx-auto font-semibold drop-shadow-md">
            Descubra destinos incríveis ao redor do mundo com a JM Travel. Experiências únicas, serviço impecável e memórias inesquecíveis.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center pt-6">
            <a href="#destinations" className="btn-primary inline-flex items-center justify-center gap-2 w-full sm:w-auto">
              EXPLORAR DESTINOS
              <ArrowRight size={20} />
            </a>
            <a href="#corporate" className="btn-outline text-white border-white hover:!bg-white hover:!text-primary w-full sm:w-auto inline-flex items-center justify-center" style={{ borderColor: '#fff', color: '#fff' }}>
              CORPORATIVO
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 inset-x-0 z-10 flex justify-center pointer-events-none">
        <div className="flex flex-col items-center gap-2 animate-bounce-soft pointer-events-auto">
          <p className="text-white text-sm font-bold">Deslize para explorar</p>
          <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  );
}
